/* eslint-disable no-mixed-operators */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { Col, Form, Row, Table } from 'react-bootstrap'
import './index.css'
import { AccountCircleOutlined, AddOutlined, ContentCopyOutlined, DeleteOutlineOutlined, DoneOutlined, KeyboardBackspaceOutlined, Language, LocalOffer, LocationOn, Markunread, Store } from '@mui/icons-material'
import { WtTheme } from '../../controller/theme'
import { deleteChannelAPI, fetchChannelLsAPI } from '../../apis/APIs'
import { AddChannelDialog, ConfirmDialog, ShowSnackbar, WtLoader } from '../../controller/BaseTool'
import { SideMenu } from './SideMenu'
import globalContext from '../../context/global/globalContext'
import { WtColor } from '../../constants/colours'
import { WtDimen } from '../../constants/dimens'
import { getLoggedUserInfo } from '../../basetool/methods'
import { WtLoginKey } from '../../constants/loginKeys'
import EmailValidator from 'email-validator'
import ChannelProfileState from '../../context/channelProfile/channelProfileState'
import ChannelProfileContext from '../../context/channelProfile/channelProfileContext'

export const ChannelsApp = () => {
  return (<ChannelProfileState><Channels /></ChannelProfileState>)
}

export const Channels = () => {
  const description = useContext(ChannelProfileContext)
  const categoryKey = useContext(ChannelProfileContext)
  const address = useContext(ChannelProfileContext)
  const email = useContext(ChannelProfileContext)
  const Website = useContext(ChannelProfileContext)
  const setChannelNo = useContext(ChannelProfileContext)
  const displayName = useContext(ChannelProfileContext)
  const setdisplayName = useContext(ChannelProfileContext)
  const updateProfile = useContext(ChannelProfileContext)

  const notificationBarStatus = useContext(globalContext)
  const channelLs = useContext(globalContext)
  const setChannelLs = useContext(globalContext)

  const isLoading = useContext(globalContext)
  const handleWTLoader = useContext(globalContext)

  const updateProfileData = {
    businessProfile: {
      address: address.address,
      description: description.description,
      vertical: categoryKey.categoryKey,
      about: displayName.displayName,
      email: email.email,
      websites: Website.Website
    }
  }

  const handleSaveProfile = () => {
    if (email.email && Website.Website && categoryKey) updateProfile.updateProfile(updateProfileData)
  }

  // Snackbar Code
  const [errorMsg, setErrorMsg] = useState("")
  const [errorMsgBg, setErrorMsgBg] = useState(WtColor.RedColor)
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const SnackbarShow = (errorMsg, errorMsgBg) => {
    setErrorMsg(errorMsg)
    setErrorMsgBg(errorMsgBg)
    setOpenSnackbar(true)
  }
  const SnackbarClose = () => {
    setOpenSnackbar(false)
  }
  // End of Snackbar Code

  // Channel UI Selection
  const [channelUI, setChannelUI] = useState("chLsUI") //chLsUI | chProfileUI
  const handleChannelUI = (ui) => setChannelUI(ui)
  // End of Channel UI Selection

  const onClickButtonCopy = (evt) => {
    navigator.clipboard.writeText(evt)
    SnackbarShow("Copied to clipboard", WtColor.BaseColor)
  }

  const [openAddChannelDialog, setOpenAddChannelDialog] = useState({ open: false, onClose: null })
  const openAddChannelDialogBox = () => {
    setOpenAddChannelDialog({
      open: true, onClose: (confirm) => {
        setOpenAddChannelDialog(false)
        if (confirm) fetchAllChannels()
      }
    })
  }

  const handleProfileClick = (evt) => {
    console.log("channelNo: ", evt)
    setChannelNo.setChannelNo(evt.whatsapp)
    setdisplayName.setdisplayName(evt.title)
    handleChannelUI("chProfileUI")
  }

  const [openConfirmDialogBox, setOpenConfirmDialogBox] = useState({ open: false, onClose: null })
  const openConfirmationForDeletionBox = (id) => {
    setOpenConfirmDialogBox({
      open: true,
      title: "Channel Deletion",
      message: "Are your sure to delete this Channel?",
      onClose: (confirm) => {
        setOpenConfirmDialogBox(false)
        if (confirm) deleteChannels(id)
      }
    })
  }

  // List of Channels
  const fetchAllChannels = async () => {
    handleWTLoader.handleWTLoader(true)
    try {
      const response = await fetchChannelLsAPI()
      if (response.status === 200) {
        setChannelLs.setChannelLs(response.data.data)
        response.data.data?.map((_v, i) => {
          localStorage.setItem("c" + (i + 1), response.data.data[i]?.whatsapp)
          localStorage.setItem("cObj", JSON.stringify(response.data?.data))
        })
        handleWTLoader.handleWTLoader(false)
      } else {
        handleWTLoader.handleWTLoader(false)
      }
    } catch (err) {
      handleWTLoader.handleWTLoader(false)
    }
  }
  // End of List of Channels

  // Delete Channels
  const deleteChannels = async (id) => {
    handleWTLoader.handleWTLoader(true)
    try {
      const data = "_id=" + id
      const response = await deleteChannelAPI(data)
      if (response.status === 204) {
        fetchAllChannels()
        handleWTLoader.handleWTLoader(false)
      } else {
        handleWTLoader.handleWTLoader(false)
      }
    } catch (err) {
      handleWTLoader.handleWTLoader(false)
    }
  }
  // End of Delete Channels

  useEffect(() => { fetchAllChannels() }, [])

  const profile_base_view = { display: "flex", backgroundColor: "#f8f8f8", height: notificationBarStatus.notificationBarStatus ? "90vh" : "98vh", width: "94vw" }
  const profile_menu_item = { flex: "0.85" }
  return (
    <div style={profile_base_view}>
      <SideMenu />
      <div style={profile_menu_item} className="bg-white">
        {isLoading.isLoading && <WtLoader open={isLoading.isLoading} />}
        <ShowSnackbar open={openSnackbar} errorMsg={errorMsg} errorMsgBg={errorMsgBg} duration={3000} close={SnackbarClose} />
        {openConfirmDialogBox.open && (<ConfirmDialog open={openConfirmDialogBox.open} title={openConfirmDialogBox.title} message={openConfirmDialogBox.message} onClose={openConfirmDialogBox.onClose} />)}
        {openAddChannelDialog.open && (<AddChannelDialog open={openAddChannelDialog.open} onClose={openAddChannelDialog.onClose} />)}
        <div>
          <div className="border-bottom ps-3 pt-2 pb-1 pe-5" style={{ display: "flex" }}>
            <div style={{ flex: 1, paddingTop: "4px" }}>
              <h5 style={{ color: WtColor.TextDarkColor, fontSize: "16px" }}>
                {channelUI === "chProfileUI" && <KeyboardBackspaceOutlined onClick={() => handleChannelUI("chLsUI")} style={{ marginRight: "5px" }} role="button" />}
                {channelUI === "chProfileUI" ? "Channel Profile" : "Channels"}
              </h5>
            </div>
            {
              channelUI !== "chProfileUI" &&
              <div>
                <button onClick={() => openAddChannelDialogBox()} className="btn btn-sm float-end" style={{ background: WtColor.BaseColor, color: "#fff", borderRadius: WtDimen.borderRadius }}>
                  <AddOutlined style={{ fontSize: "18px", marginTop: "-4px" }} />Add Channels</button>
              </div>
            }
            {
              channelUI === "chProfileUI" &&
              <div>
                <button onClick={() => { handleSaveProfile() }} className="btn btn-sm float-end" style={{ background: WtColor.BaseColor, color: "#fff", borderRadius: WtDimen.borderRadius }}>
                  <DoneOutlined style={{ fontSize: "18px", marginTop: "-4px" }} />Save Profile
                </button>
              </div>
            }
          </div>

          <div className="channel_ui">
            {
              channelUI === "chLsUI" &&
              <div className="mt-2 ps-2">
                <div className="app_list" style={{ height: "610px" }}>
                  <Table className="fw-bold" responsive>
                    <thead style={{ background: WtColor.LineColor, color: WtColor.TextLightGrey, fontSize: "15px", }}>
                      <tr>
                        <th>Type</th><th>Name</th><th>Webhook URL</th><th>WhatsApp</th>
                        {(getLoggedUserInfo(WtLoginKey.userRole) !== "admin") && <th>Action</th>}
                      </tr>
                    </thead>
                    <tbody style={{ background: "#fff", fontSize: "12px" }}>
                      {
                        channelLs.channelLs?.map((v, i) => {
                          let apiKeyOrToken = ""
                          if (v.apiKey) apiKeyOrToken = v.apiKey
                          if (v.wabaToken) apiKeyOrToken = v.wabaToken
                          return (
                            <tr className="hand" key={i}>
                              <td>
                                {(() => {
                                  if (v.type === "dialog360" || v.type === "whiteLabel") {
                                    return (
                                      <img src={WtTheme.ImageBaseUrl + "/dialog360.png"} style={{ width: "30px", height: "30px" }} alt={WtTheme.SiteName} className="img-fluid" />
                                    )
                                  }
                                  if (v.type === "waba") {
                                    return (
                                      <img src={WtTheme.ImageBaseUrl + "/whatsapp.png"} style={{ width: "30px", height: "30px", }} alt={WtTheme.SiteName} className="img-fluid" />
                                    )
                                  }
                                })()}
                              </td>
                              <td className="text-uppercase" style={{ color: WtColor.TextMidGrey, paddingTop: "16px" }}>{v.title ? v.title : "---"}</td>
                              <td style={{ color: WtColor.ProcessingBlue, paddingTop: "16px", display: "none", }}>{apiKeyOrToken?.substring(0, 20) + "..."}</td>
                              <td style={{ color: WtColor.ProcessingBlue, paddingTop: "16px", }}>{v.webhookUrl?.substring(0, 30) + "..."}&nbsp;&nbsp;<ContentCopyOutlined onClick={() => onClickButtonCopy(v.webhookUrl)} style={{ width: "14px" }} /></td>
                              <td style={{ color: WtColor.BaseColor, paddingTop: "16px", }}>{v.whatsapp} &nbsp;&nbsp;<ContentCopyOutlined onClick={() => onClickButtonCopy(v.whatsapp)} style={{ width: "14px" }} /></td>
                              {
                                (getLoggedUserInfo(WtLoginKey.userRole) !== "admin") &&
                                <td style={{ paddingTop: "16px" }}>
                                  <AccountCircleOutlined onClick={() => { handleProfileClick(v) }} style={{ color: "green", marginRight: "5px", }} />
                                  <DeleteOutlineOutlined onClick={() => openConfirmationForDeletionBox(v._id)} className="text-danger" />
                                </td>
                              }
                            </tr>
                          )
                        })}
                    </tbody>
                  </Table>
                </div>
              </div>
            }

            {channelUI === "chProfileUI" && <ChannelProfile />}
          </div>
        </div>
      </div>
    </div>
  )
}

export const ChannelProfile = () => {
  const s9 = { outline: "none", width: "100%", maxHeight: "85px", fontSize: "14px" }
  const s7 = { outline: "none", height: "36px", maxWidth: "100%", marginTop: "-7px" }
  const file = useContext(ChannelProfileContext)
  const getChannelProfile = useContext(ChannelProfileContext)
  const setFile = useContext(ChannelProfileContext)
  const description = useContext(ChannelProfileContext)
  const setDescription = useContext(ChannelProfileContext)
  const category = useContext(ChannelProfileContext)
  const setCategory = useContext(ChannelProfileContext)
  const setCategoryKey = useContext(ChannelProfileContext)
  const address = useContext(ChannelProfileContext)
  const setAddress = useContext(ChannelProfileContext)
  const email = useContext(ChannelProfileContext)
  const setEmail = useContext(ChannelProfileContext)
  const Website = useContext(ChannelProfileContext)
  const setWebsite = useContext(ChannelProfileContext)
  const displayName = useContext(ChannelProfileContext)

  const notificationBarStatus = useContext(globalContext)
  const s2 = { color: "#bfc3c9", fontSize: "22px", maxWidth: "100%" }

  // Handle image Preview//
  function handleChange(e) {
    console.log(e.target.files)
    setFile.setFile(URL.createObjectURL(e.target.files[0]))
  }
  // Handle Description field

  const handleDescription = (val) => setDescription.setDescription(val)

  const handleSelection = (e) => {
    setCategoryKey.setCategoryKey(e.target.value)
    const i = selectionArrayList.findIndex((obj) => obj.value === e.target.value)
    setCategory.setCategory(selectionArrayList[i].text)
  }

  //Handle Address field

  const handleAddress = (val) => setAddress.setAddress(val)

  //Handle Email field

  const [emailError, setEmailError] = useState("")
  const handleEmailAddress = (val) => {
    if (val !== "" && EmailValidator.validate(val)) {
      setEmailError("")
      setEmail.setEmail(val)
    } else {
      setEmailError("Please enter a valid email")
    }
  }

  //Handle Website Field
  const [WebsiteError, setWebsiteError] = useState("")
  function validURL(str) {
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
      "i",
    ) // fragment locator
    return !!pattern.test(str)
  }
  const handleWebsite = (val) => {
    if (validURL(val)) {
      setWebsiteError("")
      setWebsite.setWebsite(val)
    } else {
      setWebsiteError("Please enter a valid URL")
    }
  }

  const selectionArrayList = [
    { text: "Automotive", value: "AUTO" },
    { text: "Beauty, spa and salon", value: "BEAUTY" },
    { text: "Clothing", value: "APPAREL" },
    { text: "Education", value: "EDU" },
    { text: "Entertainment", value: "ENTERTAIN" },
    { text: "Event planning and service", value: "EVENT_PLAN" },
    { text: "Finance and banking", value: "FINANCE" },
    { text: "Food and groceries", value: "GROCERY" },
    { text: "Public service", value: "GOVT" },
    { text: "Hotel and lodging", value: "HOTEL" },
    { text: "Medical and health", value: "HEALTH" },
    { text: "Charity", value: "NONPROFIT" },
    { text: "Professional services", value: "PROF_SERVICES" },
    { text: "Shopping and retail", value: "RETAIL" },
    { text: "Travel and transportation", value: "TRAVEL" },
    { text: "Restaurant", value: "RESTAURANT" },
    { text: "Other", value: "OTHER" },
  ]

  useEffect(() => { getChannelProfile.getChannelProfile(selectionArrayList) }, [])
  return (
    <div className="app_list" style={{ padding: "45px", height: notificationBarStatus.notificationBarStatus ? '80vh' : "90vh" }}>
      <div style={{ border: "2px solid #e5e8f0", padding: "45px" }} className="rounded-3">
        <Row>
          <Col xxl={7} xl={7} lg={7} md={12} sm={12} xs={12}>
            <div style={{ marginBottom: "30px" }}>
              <h6>Profile photo</h6>
              <p>This will be visible on your business profile</p>
              <div>
                <Form.Group controlId="formFileMultiple" className="mb-3">
                  <Form.Control type="file" multiple style={{ border: "Aliceblue" }} onChange={handleChange} />
                </Form.Group>
                <p className="fw-semibold" style={{ marginBottom: "5px" }}>Display Name</p>
                <p>{displayName.displayName}</p>
                <p className="fw-semibold">Category</p>
              </div>

              <Form.Select style={{ width: "100%" }} onChange={(e) => { handleSelection(e) }}>
                {!category.category && <option>Select the Category</option>}
                {selectionArrayList.map((option) => {
                  return (
                    <option key={option.value} value={option.value} selected={option.text === category.category}>{option.text}</option>
                  )
                })}
              </Form.Select>

              <h6 className="fw-semibold mt-4">Description</h6>

              <p>Tell your customers about your company</p>
              <textarea className="rounded-2 ps-3 pt-2" onChange={(e) => handleDescription(e.target.value)} style={s9} value={description.description && (description.description)}></textarea>

              <h6 className="mt-4">Contact information</h6>
              <p>Add some contact details for your business</p>
              <p>Address:</p>
              <input type="text" className="ps-3 rounded-2" onChange={(e) => handleAddress(e.target.value)} style={s7} value={address.address && (address.address)} placeholder="Enter Business Address" />
              <p className="mt-3">Email address:</p>
              <input type="text" className="ps-3 rounded-2" onChange={(e) => handleEmailAddress(e.target.value)} style={s7} value={email.email && (email.email)} placeholder="Enter Business Email Address" />
              <p style={{ color: "red", fontSize: "12px" }}>{emailError && (emailError)}</p>
              <p className="mt-3">Website:</p>
              <input type="text" className="ps-3 rounded-2" onChange={(e) => handleWebsite(e.target.value)} style={s7} value={Website.Website && (Website.Website)} placeholder="https:/www.example.com" />
              <p style={{ color: "red", fontSize: "12px" }}>{WebsiteError && (WebsiteError)}</p>
            </div>
          </Col>

          <Col xxl={5} xl={5} lg={5} md={12} sm={12} xs={12}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", }}>
              <h6 className="ps-3 text-left">Business Profile View</h6>
              <div>
                {
                  file.file &&
                  <img src={file.file} alt="user Profilepic" style={{ maxHeight: "300px", maxWidth: "250px" }} />
                }
                {
                  !file.file &&
                  <img src="https://user-images.githubusercontent.com/117907145/218411435-8acd88e8-b5fa-41ac-95a3-0568acb3022f.png" alt="user Profilepic" style={{ maxHeight: "300px", maxWidth: "250px" }} />
                }
              </div>
              <div className="bg-gray" style={{ width: "300px", marginTop: "20px" }} >
                {
                  description.description !== "" &&
                  (
                    <div style={{ width: "300px", display: "flex" }}>
                      <Store style={s2} />
                      <p style={{ width: "300px", wordBreak: "break-all", marginLeft: "3px", }}>{description.description}</p>
                    </div>
                  )}
                {
                  category.category !== "" &&
                  (
                    <div style={{ width: "300px", display: "flex" }}>
                      <LocalOffer style={s2} />
                      <p style={{ width: "300px", wordBreak: "break-all", marginLeft: "3px" }}>{category.category}</p>
                    </div>
                  )}
                {
                  address.address !== "" &&
                  (
                    <div style={{ width: "300px", display: "flex" }}>
                      <LocationOn style={s2} />
                      <p style={{ width: "300px", wordBreak: "break-all", marginLeft: "3px", color: "#4ca89d" }}>{address.address}</p>
                    </div>
                  )}
                {
                  email.email !== "" &&

                  <div style={{ width: "300px", display: "flex" }}>
                    <Markunread style={s2} />
                    <p style={{ width: "300px", wordBreak: "break-all", marginLeft: "3px", color: "#4ca89d" }}>{email.email}</p>
                  </div>
                }
                {
                  Website.Website !== "" &&
                  <div style={{ width: "300px", display: "flex" }}>
                    <Language style={s2} />
                    <p style={{ width: "300px", wordBreak: "break-all", marginLeft: "3px", color: "#4ca89d" }}>{Website.Website}</p>
                  </div>
                }
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div >
  )
}
